
import Vue from "vue";

export default Vue.extend({
  name: "WindExclusionModal",
  methods: {
    handleCloseWindExclusionSignModal() {
      this.$modal.hide("windExclusionSignModal");
      this.$emit("continue");
    }
  }
});
